export default __webpack_public_path__ + "static/media/Gold_Oct_Rank.75fba161.png";